export default __webpack_public_path__ + "static/EverydayEmpowerInsights5-2ac8c4b915f5830aa7d096cbd5736f90.png";